import styled from 'styled-components'

export const ToggleContainer = styled.div<{ $active: string }>`
  display: grid;
  grid-template-columns: 155px 120px;
  position: relative;
  border-radius: 16px;
  background: #f6f6f6;
  width: 275px;
  height: 38px;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: ${(props) => (props.$active === 'class' ? '155px' : '120px')};
    height: 100%;
    background-color: #313131;
    border-radius: 16px;
    transition: transform 0.4s ease;
    transform: translateX(
      ${(props) => (props.$active === 'class' ? '0%' : '155px')}
    );
  }
`

export const Button = styled.button<{ $isActive: boolean; $width: number }>`
  display: flex;
  width: ${(props) => `${props.$width}px`};
  height: 38px;
  padding: 8px 16px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  border: none;
  border-radius: 16px;
  background: transparent;

  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.28px;
  cursor: pointer;
  color: ${(props) =>
    props.$isActive ? '#f6f6f6' : '#8e92bc'}; // Cambiar color de texto
  transition: color 0.4s ease;
  z-index: 2;

  &:focus {
    outline: none;
  }
`
